import React, { useState } from "react";
import ReportsTabs from "../common-elements/ReportsTabs";
import StaticTableContent from "./elements/StaticTableContent";
import TopPage from "./elements/topPage";

const DriverRevenue = () => {
  return (
    <React.Fragment>
      <div className="position-relative subheader-wrapper">
        <ReportsTabs activeTab={11} />
        <div className="page-fluid">
          <TopPage />
          <StaticTableContent />
        </div>
      </div>
    </React.Fragment>
  );
};

export default DriverRevenue;
